import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import './App.css';
import CheckStockPage from "./components/CheckStockPage";
import CustomerDetailsPage from "./components/CustomerDetailsPage";
import HomePage from "./components/HomePage";
import LoginPage from "./components/LoginPage";
import MakeOrderPage from "./components/MakeOrderPage";
import PreviousOrderDetailPage from "./components/PreviousOrderDetailPage";
import PreviousOrderPage from "./components/PreviousOrderPage";
import ProtectedRoute from "./components/ProtectedRoute";
import ViewPDFFile from "./components/ViewPDFFile";
import StartingPage from "./components/StartingPage";
import RegisterMachine from "./components/RegisterMachine";
import ProtectedMachineRoute from "./components/ProtectedMachineRoute";

function App() {
  return (
    <Router>

      <Routes>

       {/* use machine validation if needed else comment it
       ie below 2 routes / and /login inside protectedmachineroute */}
        {/* <Route exact path="/" element={<StartingPage />} /> */}

        {/* <Route path="/login" element={
          <ProtectedMachineRoute>
            <LoginPage />
          </ProtectedMachineRoute>

        } /> */}

        <Route exact path="/" element={<LoginPage />} />

        <Route
          path="/home"
          element={
            // Good! Do your composition here instead of wrapping <Route>.
            // This is really just inverting the wrapping, but it's a lot
            // more clear which components expect which props.
            <ProtectedRoute >
              <HomePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/check_stock"
          element={
            <ProtectedRoute >
              <CheckStockPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/customer_details"
          element={
            <ProtectedRoute >
              <CustomerDetailsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/make_order"
          element={
            <ProtectedRoute >
              <MakeOrderPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/previous_order"
          element={
            <ProtectedRoute >
              <PreviousOrderPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/previous-order-details/:id"
          element={
            <ProtectedRoute >
              <PreviousOrderDetailPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/view-pdf"
          element={
            // Good! Do your composition here instead of wrapping <Route>.
            // This is really just inverting the wrapping, but it's a lot
            // more clear which components expect which props.
            <ProtectedRoute >
              <ViewPDFFile />
            </ProtectedRoute>
          }
        />

      </Routes>

    </Router>
  );
}

export default App;
